module.exports = __webpack_public_path__ + "img/quote-apartment.56fa4057.gif";